import { useMemo } from "react";
import type { MotionValue } from "framer-motion";
import { beatIndexAtProgress, useBeatIndex } from "./beat-index";
import type { KeyframeBand, KeyframeIndex } from "./types";

export type GraphModalKind = "workload" | "drift" | "finding";

export interface GraphScene {
  beat: KeyframeIndex;
  modal: GraphModalKind | null;
  modalOpacity: 0 | 1;
  showInventory: boolean;
  showGraph: boolean;
  showWorkload: boolean;
  showDrift: boolean;
  showFinding: boolean;
  dimBase: boolean;
}

export function graphSceneForBeat(beat: KeyframeIndex): GraphScene {
  const modal =
    beat === 4 ? "workload"
    : beat === 5 ? "drift"
    : beat === 6 ? "finding"
    : null;

  return {
    beat,
    modal,
    modalOpacity: modal ? 1 : 0,
    showInventory: beat >= 2,
    showGraph: beat >= 3,
    showWorkload: beat >= 4,
    showDrift: beat >= 5,
    showFinding: beat >= 6,
    dimBase: beat >= 5,
  };
}

export function graphSceneAtProgress(
  progress: number,
  bands: readonly KeyframeBand[],
): GraphScene {
  return graphSceneForBeat(beatIndexAtProgress(progress, bands));
}

export function useGraphScene(
  progress: MotionValue<number>,
  bands: readonly KeyframeBand[],
): GraphScene {
  const beat = useBeatIndex(progress, bands);
  return useMemo(() => graphSceneForBeat(beat), [beat]);
}
